import { createContext, useContext } from 'react'

type TTranslationContext = {
  translationHash?: string
  languages?: string[]
}

export const TranslationContext = createContext<TTranslationContext>({})

export const useTranslation = (): TTranslationContext => {
  const value = useContext(TranslationContext)
  return value
}
